import React, { useEffect, useState } from "react";
import { TOK, SERIF, SANS, PrimaryBtn, QuietLink, Title } from "./shared";
import { ExplainInput, MIN_EXPLAIN } from "./ExplainInput";
import { RepeatCard } from "./RepeatBits";

export const EXPLAIN_PLACEHOLDER = "For example: I get really nervous when I have to speak in front of people.";

// Step 1 — Explain. Shown inside the flow when the user comes back to edit.
export const TellStep = ({ intent, setIntent, onSubmit, onMoreOptions, error, last, onRepeat, onOwnWords }) => (
  <div className="space-y-7" data-testid="simple-tell-step">
    {last && <RepeatCard last={last} onRepeat={onRepeat} />}
    <Title>What would you like to change?</Title>
    <ExplainInput value={intent} onChange={setIntent} placeholder={EXPLAIN_PLACEHOLDER} />
    {error && <p className="text-sm" style={{ color: "#e9a39c", fontFamily: SANS }} data-testid="simple-tell-error">{error}</p>}
    <PrimaryBtn testId="simple-tell-submit" disabled={intent.trim().length < MIN_EXPLAIN} onClick={onSubmit}>Begin</PrimaryBtn>
    <QuietLink testId="simple-own-words" onClick={onOwnWords}>I already have my words ›</QuietLink>
    <QuietLink testId="simple-more-options" onClick={onMoreOptions}>More options ›</QuietLink>
  </div>
);

// Drop in a ready-made list of affirmations (e.g. from a coaching session).
export const ListStep = ({ text, setText, onSubmit, error }) => (
  <div className="space-y-6" data-testid="simple-list-step">
    <Title>Drop in your words</Title>
    <p className="text-sm" style={{ color: TOK.creamDim, fontFamily: SANS }}>One affirmation per line. Soulumo keeps your words, just tidies spelling and makes each line "I…".</p>
    <textarea value={text} onChange={(e) => setText(e.target.value)} rows={10} data-testid="simple-list-input"
      placeholder={"I am enough.\nI deserve to rest without guilt.\nI speak up calmly and clearly."}
      className="w-full rounded-2xl p-4 text-base outline-none resize-y"
      style={{ background: "rgba(241,236,221,0.05)", border: "1px solid rgba(215,187,122,0.25)", color: TOK.cream, fontFamily: SERIF }} />
    {error && <p className="text-sm" style={{ color: "#e9a39c", fontFamily: SANS }} data-testid="simple-list-error">{error}</p>}
    <PrimaryBtn testId="simple-list-submit" disabled={text.split("\n").filter((l) => l.trim().length > 2).length < 2} onClick={onSubmit}>Use my words</PrimaryBtn>
  </div>
);

const STAGES = [[0, "Soulumo Coach is listening…"], [6, "Choosing the right words for you…"], [18, "Shaping your installation…"], [40, "Nearly there, just a few more moments…"]];

export const ThinkingStep = () => {
  const [t, setT] = useState(0);
  useEffect(() => { const i = setInterval(() => setT((x) => x + 1), 1000); return () => clearInterval(i); }, []);
  const line = STAGES.filter(([at]) => t >= at).pop()[1];
  return (
    <div className="py-16 flex flex-col items-center gap-5 text-center" data-testid="simple-thinking">
      <div className="w-16 h-16 rounded-full animate-pulse" style={{ background: "radial-gradient(circle, rgba(215,187,122,0.6), transparent 70%)" }} />
      <p className="text-xl italic" style={{ color: TOK.creamDim, fontFamily: SERIF }} data-testid="simple-thinking-line">{line}</p>
      {t >= 6 && <p className="text-xs" style={{ color: TOK.creamMist, fontFamily: SANS }}>This usually takes 20–40 seconds.</p>}
    </div>
  );
};
